import React from 'react';
import {
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography,
  styled,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

interface NewSectionButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const CustomCardActionArea = styled(CardActionArea)({
  '.MuiCardActionArea-focusHighlight': {
    background: '#ffffff',
  },
});

const NewSectionButton: React.FC<NewSectionButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: '10px',
        border: '1px dashed #CBD5E1',
        '&:hover': { boxShadow: '0px 14px 40px 0px #6E9DB22E' },
      }}
    >
      <CustomCardActionArea disabled={disabled} onClick={onClick}>
        <CardContent sx={{ p: '16px' }}>
          <Stack alignItems="center">
            <Typography display="flex" alignItems="center" color="info.main">
              <AddIcon sx={{ mr: '5px' }} /> Add New Item
            </Typography>
          </Stack>
        </CardContent>
      </CustomCardActionArea>
    </Card>
  );
};

export default NewSectionButton;
